import React from 'react';

export default function Category(){
    return(
        <>
        {/* <h1>Carousel con categorias</h1> */}
        </>
    )
}